import {
  loadJS, templateStr, objectMap, createLoaded,
} from './utils';

/**
 * 多语言云资源管理器
 */
const Resources = class {
  constructor($config, $ctx) {
    this.$installer = {
      /**
       * 资源数据
       */
      data: {},
      /**
       * 多语言加载方法（可重写）
       */
      load: (lang) => new Promise((resolve, reject) => {
        // 挂载全局资源安装函数（JSONP回调）
        window[$config.resources.callbackMethod.format({ lang })] = res => { resolve(res); };
        // 远程加载资源JS
        const resUrl = `${$config.resources.file.format({
          runtime: $ctx.runtime,
          appName: $config.log.appName,
          lang,
        })}?t=${window.parseInt((new Date().getTime() / $config.resources.cacheExpires))}`;
        loadJS(resUrl).catch(error => {
          console.warn(`load resources [${resUrl}] error:`, error);
          reject(error);
        });
      }),
      /**
       * 安装多语言资源
       */
      install: createLoaded(lang => ($config.resources ? this.$installer.load(lang).then(res => {
        this.$installer.data[lang] = res;
      }) : Promise.resolve())),
    };

    Object.setPrototypeOf(this, this.$installer.data);

    // 计算res对象函数
    this.computeRes = (lang, moduleName, inlineRes) => {
      if (!$config.resources) return {};
      let res = null;
      if (!moduleName) {
        res = {};
      } else {
        res = { ...this[lang]?.[$config.resources?.commonModule], ...this[lang]?.[moduleName] };

        if (inlineRes && typeof inlineRes === 'object') {
          // 开发环境允许自定义多语言对象用于调试
          if (!$ctx.isDev()) {
            console.warn(`$resources: 模块${moduleName}(${lang})在非dev环境中使用了内联res对象`);
          }
          res = Object.assign(res, inlineRes[$ctx.lang] ?? {});
        }
      }

      // 模版字符串处理
      res = objectMap(res, i => (typeof i === 'string' ? templateStr(i, '', window.$hobbit) : i), true);

      // 返回代理拦截后的res对象
      return new Proxy(res, {
        get(target, prop, receiver) {
          let newProp = null;
          if (typeof prop === 'string' && $ctx.biz) {
            newProp = `${prop}@${$ctx.biz}`;
            if (!(newProp in target)) {
              if (prop in target) {
                newProp = prop;
              } else if (!/^__|^\$/.test(prop)) {
                console.warn(`$resources: ${lang} > ${moduleName} > ${prop} is missing`);
                return '';
              }
            }
          } else {
            newProp = prop;
          }
          return Reflect.get(target, newProp, receiver);
        },
      });
    };
  }
};

export default Resources;
